import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  ADD_PARTNER_AC_TAG,
  CHANGE_PASSWORD,
  CHANGE_SECURITY_QUESTION,
  CHANGE_USER_NAME,
  LOG_OUT_USER,
  UPDATE_USER_PROFILE,
  USER_PROFILE,
} from "helper/url_helper";
import { toast } from "react-toastify";
import { axiosAccount } from "services/api";
import { clear, get } from "services/cookies";
import { clearLocal } from "services/localStorage";
import {
  FETCH_USER,
  FETCH_USER_LOADING,
  HANDLE_EDIT_PROFILE,
  LOGOUT,
  SET_IS_AUTH,
  SET_TOKEN,
} from "./actionTypes";

export const fetchUserProfile = payload => {
  return async dispatch => {
    try {
      dispatch(fetchUserLoading(true));
      const res = await axiosAccount.get(USER_PROFILE);
      if (res?.data?.data?.user) {
        dispatch(fetchUserSuccess(res.data?.data?.user));
        dispatch(fetchUserLoading(false));
      }
    } catch (err) {
      dispatch(fetchUserLoading(false));
      errorTostHandler(err);
    }
  };
};

export const logOutUser = (cb = () => {}) => {
  return async dispatch => {
    try {
      dispatch(fetchUserLoading(true));
      const token = get("token");
      await axiosAccount.post(LOG_OUT_USER, {
        token: token,
      });
      cb();
      clear();
      clearLocal();
      dispatch(logout());
      dispatch(fetchUserLoading(false));
    } catch (err) {
      dispatch(fetchUserLoading(false));
      errorTostHandler(err);
    }
  };
};

export const ChangeUserName = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(handleEditDataLoading(true));
      const res = await axiosAccount.post(CHANGE_USER_NAME, payload);
      if (!!res?.data) {
        cb(res);
        dispatch(handleEditDataLoading(false));
      }
    } catch (err) {
      dispatch(handleEditDataLoading(false));
      errorTostHandler(err);
    }
  };
};

export const ChangePassword = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(handleEditDataLoading(true));
      const res = await axiosAccount.post(CHANGE_PASSWORD, payload);
      if (!!res?.data) {
        cb(res);
        toast.success(res.data?.message);
        dispatch(handleEditDataLoading(false));
      }
    } catch (err) {
      dispatch(handleEditDataLoading(false));
      errorTostHandler(err);
    }
  };
};

export const changeSecurityQuestion = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(handleEditDataLoading(true));
      const res = await axiosAccount.post(CHANGE_SECURITY_QUESTION, payload);
      if (!!res?.data) {
        cb(res);
        toast.success(res.data?.message);
        dispatch(handleEditDataLoading(false));
      }
    } catch (err) {
      dispatch(handleEditDataLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handleEditUserProfile = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(handleEditDataLoading(true));
      const res = await axiosAccount.post(UPDATE_USER_PROFILE, payload);
      if (!!res?.data) {
        cb(res);
        dispatch(handleEditDataLoading(false));
      }
    } catch (err) {
      dispatch(handleEditDataLoading(false));
      errorTostHandler(err);
    }
  };
};

export const partnerACTag = payload => {
  return async dispatch => {
    try {
      await axiosAccount.post(ADD_PARTNER_AC_TAG, payload);
    } catch (err) {
      errorTostHandler(err);
    }
  };
};

export const handleIsAuth = data => ({
  type: SET_IS_AUTH,
  payload: data,
});

export const handleSetToken = data => ({
  type: SET_TOKEN,
  payload: data,
});

export const logout = () => ({
  type: LOGOUT,
});

export const fetchUserLoading = data => ({
  type: FETCH_USER_LOADING,
  payload: data,
});

export const fetchUserSuccess = data => ({
  type: FETCH_USER,
  payload: data,
});

export const handleEditDataLoading = data => ({
  type: HANDLE_EDIT_PROFILE,
  payload: data,
});
